module.exports = __webpack_public_path__ + "static/media/8OLA17.5d947a19.jpg";